import { createFileRoute } from '@tanstack/react-router';

type Search = {
  selectedLabel?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/contacts/$filter')({
  staticData: { team: 'fe-ux-platform' },
  validateSearch: (search: Search) => {
    return {
      selectedLabel: search.selectedLabel,
    };
  },
});
